<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<div style="page-break-after:always"></div><p class="CHAPTER1" id="_idParaDest-2"><a id="_idTextAnchor001"></a>Acknowledgements</p>
<p class="FIRSTPARAGRAPH">This book would not exist but for the unstinting efforts of Steven J. Anzalone, my brother and keeper; Walker Kornfeld, my editor and literary surgeon; and Craig Carda, enabler to us all.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0004.vue?757baa63